module.exports = __webpack_public_path__ + "media/main2024_video.d3ddf6c0.webm";